/**
 * tablesort_time.js
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

import tablesort from "tablesort";

const pattern = val => /(?:\d\d?:\d\d|\*)/.test(val);

const compare = (a, b) => {
    let aTokens,
        bTokens;

    aTokens = (a === "*" || a === "-") ? [-1, 0] : a.split(/:/);
    bTokens = (b === "*" || b === "-") ? [-1, 0] : b.split(/:/);

    let diff = parseInt(aTokens[0], 10) - parseInt(bTokens[0], 10);
    if (diff === 0) {
        diff = parseInt(aTokens[1], 10) - parseInt(bTokens[1], 10);
    }

    return diff;
};

tablesort.extend("time", pattern, compare);
